// extracted by mini-css-extract-plugin
export default {"container":"ConversationFiles_container__Oyldp","filesContainer":"ConversationFiles_filesContainer__WNg6D","filePreview":"ConversationFiles_filePreview__-sL5v"};